import { IconProps } from "../../utils/global-types/global-types";

const TranslateIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_2023_5305)">
        <path d="m10.539 10.38-.571-1.142-.572 1.143z"></path>
        <path d="M12.77 5.935h-.58V4.706a.41.41 0 0 0-.452-.408c-.066.007-1.529.172-2.257 1.637h-.596v.9c0 1.13-.92 2.05-2.05 2.05h-.9v3.885c0 .678.552 1.23 1.23 1.23h5.605c.678 0 1.23-.552 1.23-1.23V7.165c0-.678-.552-1.23-1.23-1.23m-4.815 5.496L9.6 8.138a.41.41 0 0 1 .734 0l1.646 3.293a.41.41 0 0 1-.734.367l-.298-.597H8.987l-.299.597a.41.41 0 1 1-.733-.367M4.42 3.455h-.776q.075.61.388 1.023.312-.413.389-1.023"></path>
        <path d="M6.835 8.065c.678 0 1.23-.552 1.23-1.23V1.23C8.065.552 7.513 0 6.835 0H1.23C.552 0 0 .552 0 1.23v5.605c0 .678.552 1.23 1.23 1.23h.581v1.23a.41.41 0 0 0 .452.407c.065-.006 1.528-.172 2.256-1.637zM4.25 5.71a3 3 0 0 1-.219-.13 3 3 0 0 1-.218.13c-.7.374-1.399.378-1.428.378a.41.41 0 0 1 0-.82c.004 0 .51-.008 1.013-.267-.288-.368-.515-.869-.58-1.547h-.433a.41.41 0 0 1 0-.82h1.236v-.25a.41.41 0 0 1 .82 0v.25H5.68a.41.41 0 0 1 0 .82h-.433c-.065.678-.292 1.179-.58 1.547a2.5 2.5 0 0 0 1.014.267.41.41 0 1 1-.001.82c-.03 0-.728-.004-1.428-.378M9.999 2.347a.41.41 0 0 0 .58 0 .41.41 0 0 0 0-.58l-.118-.118a2.886 2.886 0 0 1 2.71 2.877.41.41 0 0 0 .821 0 3.707 3.707 0 0 0-3.54-3.699L10.58.7a.41.41 0 1 0-.58-.58l-.823.823a.41.41 0 0 0 0 .58zM3.993 11.645a.41.41 0 1 0-.58.58l.118.117A2.886 2.886 0 0 1 .82 9.465a.41.41 0 0 0-.821 0 3.71 3.71 0 0 0 3.54 3.7l-.127.126a.41.41 0 0 0 .58.58l.823-.823a.41.41 0 0 0 0-.58z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2023_5305">
          <path fill="#fff" d="M0 0h14v14H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TranslateIcon;
